import { GridReadyEvent } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { AgFns, GridOptionsExt } from 'app/shared/ag-fns';
import { ShipFrequency } from 'app/model/entities/ship-frequency';
import { ShipFrequencyCode } from 'app/model/enums/ship-frequency-code';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from 'app/shared/domain.service';
import { DialogBaseComponent } from 'app/shared/dialog-base.component';

@Component({
  templateUrl: "./ship-frequency-dialog.component.html",
  standalone: false,
})
export class ShipFrequencyDialogComponent extends DialogBaseComponent<any> {
  sfGridOptions: GridOptionsExt;
  shipFrequencies: ShipFrequency[];

  weekDays = [
    { id: "MO", name: "Monday" },
    { id: "TU", name: "Tuesday" },
    { id: "WE", name: "Wednesday" },
    { id: "TH", name: "Thursday" },
    { id: "FR", name: "Friday" },
    { id: "SA", name: "Saturday" },
    { id: "SU", name: "Sunday" },
  ];

  constructor(public config: DynamicDialogConfig<any>, public dialogRef: DynamicDialogRef, public domainService: DomainService) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Edit Ship Frequency Info",
      width: "700px",
      height: "500px",
    });

    this.prepare();
  }

  async prepare() {
    this.sfGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onSfGridReady,
      stopEditingWhenCellsLoseFocus: true,
    });

    this.shipFrequencies = this.dbQueryService.getAllCached(ShipFrequency);

    this.isPageReady = true;
  }

  onSfGridReady(event: GridReadyEvent) {
    const colDefs = [
      { headerName: 'Name', field: 'name', editable: false },
      {
        headerName: 'Day of week to ship',
        ...AgFns.createDropdownEditor('rRuleByWeekDay', this.weekDays),
        editable: this.isEditableRow.bind(this),
        cellClass: this.getEditableClass.bind(this)
      },
      {
        headerName: 'Min days for new bin',
        field: 'minDaysForNewBin',
        editable: this.isEditableRow.bind(this),
        cellClass: this.getEditableClass.bind(this),
        cellDataType: 'number',
        valueSetter: function(params) {
          var val = +params.newValue;
          var maxDays = 0;
          if (params.data.id == ShipFrequencyCode.Every2Weeks) {
            maxDays = 13;
          } else if (params.data.id == ShipFrequencyCode.Every3Weeks) {
            maxDays = 20;
          }
          params.data.minDaysForNewBin = Math.max(0, Math.min(val, maxDays));
          return true;
        },
      },
    ];
    // AgFns.updateColDefs(colDefs);
    // this.sfGridOptions.apiX.setGridOption('columnDefs', colDefs);

    AgFns.initGrid(event, colDefs);
    AgFns.sizeColumnsToFit(this.sfGridOptions);
  }

  isEditableRow(p: any) {
    const sf = p.data as ShipFrequency;
    return sf.id > ShipFrequencyCode.Immediate && sf.id < ShipFrequencyCode.WhenBinIsFull;
  }

  getEditableClass(p: any) {
    return this.isEditableRow(p) ? "cell-editable" : "";
  }

  hasChanges() {
    return this.dbSaveService.uow.hasChanges();
  }

  showMinDaysInfo() {
    this.dialogService.infoDialog(
      "Min Days for New Bin",
      "This is the minimum number of days from today before a new bin's expected ship date can be scheduled. " +
      "It ensures there is enough lead time to accumulate items in a bin before it ships." +
      "<br><br>" +
      "For example, if set to <b>3</b>, a bin created today will be assigned the next shipping day that is at least 3 days out.",
    );
  }

  async ok() {
    await this.dbSaveService.saveChanges();
    this.dialogRef.close(true);
  }

  cancel() {
    this.dbSaveService.rejectChanges();
    this.dialogRef.close(null);
  }
}
